import { Caption } from '@farol-ds/react'
import classNames from 'classnames'
import React from 'react'

import styles from './chat-input-shell.module.scss'

export interface ChatInputShellDisclaimerProps {
  children?: React.ReactNode
  className?: string
}

export function ChatInputShellDisclaimer({ children, className }: ChatInputShellDisclaimerProps) {
  return <Caption className={classNames(styles.disclaimer, className)}>{children}</Caption>
}
